import { alpha } from '@mui/material/styles';

const NAMED_COLORS = {
  white: '#ffffff',
  orange: '#ffa500',
  green: '#008000',
  red: '#ff0000',
  blue: '#0000ff',
  deeppink: '#ff1493',
};

export function resolveBookingCardColor(input, theme, fallback = theme.palette.primary.main) {
  if (input == null || typeof input !== 'string') return fallback;

  const trimmed = input.trim();
  const lower = trimmed.toLowerCase();
  if (NAMED_COLORS[lower]) return NAMED_COLORS[lower];
  if (trimmed.startsWith('#') || trimmed.startsWith('rgb') || trimmed.startsWith('hsl')) {
    return trimmed;
  }

  const segments = trimmed.split('.');
  if (segments.length === 1) {
    const slot = theme.palette[segments[0]];
    if (slot && typeof slot === 'object' && slot.main != null) return slot.main;
  }

  let node = theme.palette;
  for (const segment of segments) {
    node = node?.[segment];
  }

  return typeof node === 'string' ? node : fallback;
}

function parseHexColor(input) {
  if (!input.startsWith('#')) return null;

  let hex = input.slice(1);
  if (hex.length === 3 || hex.length === 4) {
    hex = hex
      .slice(0, 3)
      .split('')
      .map(char => `${char}${char}`)
      .join('');
  }

  if (hex.length !== 6 && hex.length !== 8) return null;

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  if ([r, g, b].some(value => Number.isNaN(value))) return null;
  return { r, g, b };
}

function parseRgbColor(input) {
  const match = input.match(/rgba?\(([^)]+)\)/i);
  if (!match) return null;

  const [r, g, b] = match[1]
    .split(',')
    .slice(0, 3)
    .map(part => Number(part.trim()));

  if ([r, g, b].some(value => Number.isNaN(value))) return null;
  return { r, g, b };
}

function isVisuallyLightColor(input, theme) {
  const resolved = resolveBookingCardColor(input, theme);
  const rgb = parseHexColor(resolved) || parseRgbColor(resolved);
  if (!rgb) return false;

  const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  return luminance > 0.72;
}

export function getBookingCardHoverTintColor(input, theme) {
  const resolved = resolveBookingCardColor(input, theme);
  if (theme.palette.mode === 'light' && isVisuallyLightColor(resolved, theme)) {
    return theme.palette.primary.main;
  }

  return resolved;
}

export function getBookingCardHoverOverlay(input, theme) {
  const tintColor = getBookingCardHoverTintColor(input, theme);
  const tint = alpha(tintColor, theme.palette.mode === 'light' ? 0.16 : 0.32);
  return `linear-gradient(${tint}, ${tint})`;
}

export function getBookingCardHoverBackgroundColor(input, theme) {
  const tintColor = getBookingCardHoverTintColor(input, theme);
  return alpha(tintColor, theme.palette.mode === 'light' ? 0.16 : 0.15);
}
